export default "__VITE_ASSET__CXiGNQZx__"